import React, {useEffect} from "react";
import {Link, useHistory} from "react-router-dom";
import './AnalizaMain.css'
import * as BiIcons from "react-icons/bi";


export default function SrednioZaawansowane(){

	useEffect(()=>{
		document.title="Analiza matematyczna";
	},[])

	const { push } = useHistory();

	const comeBackFunc=()=>{
		push('/analiza');
	}

	return(
		<div className='conceptsContainer'>
			<div className='comeBackDiv' onClick={comeBackFunc}>
				<BiIcons.BiArrowBack/>
				<div style={{textAlign: 'left', alignItems: 'left'}}>Cofnij</div>
			</div>

			<div className=' listOfButtons'>
				<Link to="/analiza/funkcja-jednej-zmiennej" className='link'><button className='analizaLinks'>Funkcja jednej zmiennej
				</button></Link>
				<Link to="/analiza/pojecia-wstepne/symetria-prosta" className='link'><button className='analizaLinks'>Symetria punktów i
					osi</button></Link>
				<br/><br/><br/>
			</div>
		</div>
	);
}